export default "__VITE_ASSET__0bf77d1e__"